import { Mask } from '@models/utils/mask';


export const defaultCPFMask: Mask = {
  guide:    false,
  showMask: false,
  mask:     [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/ ]
};
